var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 68,
    viewBox: "0 0 61 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2222 6.8H47.4444V0H40.6667V6.8H20.3333V0H13.5556V6.8H6.77778C3.03983 6.8 0 9.8498 0 13.6V61.2C0 64.9502 3.03983 68 6.77778 68H54.2222C57.9602 68 61 64.9502 61 61.2V13.6C61 9.8498 57.9602 6.8 54.2222 6.8ZM50.8333 57.8H30.5V37.4H50.8333V57.8ZM54.2222 23.8H6.77778V17H54.2222V23.8Z",
    fill: "#A7B4CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDate);
export default __webpack_public_path__ + "static/media/icon-date.33b0162547ed00f7c4738f27b64bf076.svg";
export { ForwardRef as ReactComponent };